import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NoiseWebWebp from '../../../../assets/noise/noise-details-banner-desktop.webp';
import NoiseMobileWebp from '../../../../assets/noise/noise-details-banner-mobile.webp';
import './NoiseInfoSection.scss';
import DisFeatureWeb from '../../../../assets/noise/dis-feature-web.webp';
import DisFeatureMobile from '../../../../assets/noise/dis-feature-mobile.webp';
const NoiseInfoSection = (props) => {
  const sliderRef = useRef(null);
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    autoplaySpeed: 3000,
  };
  useEffect(() => {
    const fetchBannerMappingData = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_SITECORE_API_HOST}/sitecore/api/ssc/aggregate/content/Items('{F8CDA01A-BB15-438E-B249-B767F59B4777}')
?$select=FieldValues
&$expand=FieldValues&sc_apikey=${process.env.REACT_APP_SITECORE_API_KEY}`
        );

        const data = await res.json();
        if (!data.FieldValues?.BannerMapDetails) return;

        // Parse BannerMap string into key-value object
        const mapObj = {};
        data.FieldValues.BannerMapDetails.split('&').forEach((pair) => {
          const [key, encodedValue] = pair.split('=');
          mapObj[key] = decodeURIComponent(encodedValue);
        });
        // ---- Begin your cookie logic ----
        const currentUrl = window.location.href.toLowerCase();

        // Find the longest matching key to avoid partial/ambiguous matches
        let matchedKey = null;
        let matchedValue = null;
        let maxKeyLength = 0;
        Object.entries(mapObj).forEach(([key, value]) => {
          if (currentUrl.includes(key.toLowerCase()) && key.length > maxKeyLength) {
            matchedKey = key;
            matchedValue = value;
            maxKeyLength = key.length;
          }
        });

        if (!matchedKey) return;

        // Only set cookie if not already set to this value
        const cookieMatch = document.cookie.match(/(?:^|; )lastVehicleVisited=([^;]*)/);
        const currentCookie = cookieMatch ? decodeURIComponent(cookieMatch[1]) : null;

        if (currentCookie !== matchedValue) {
          const setCookie = (name, value, years = 10) => {
            const expires = new Date();
            expires.setFullYear(expires.getFullYear() + years);
            document.cookie = [
              `${name}=${encodeURIComponent(value)}`,
              `expires=${expires.toUTCString()}`,
              'path=/',
              'SameSite=Strict',
              'Secure',
            ].join('; ');
          };

          setCookie('lastVehicleVisited', matchedValue);
        }
        // ---- End cookie logic ----
      } catch (err) {
        console.error('Banner Mapping API error:', err);
      }
    };

    fetchBannerMappingData();
  }, []);
  return (
    <>
      {/* <!--HOme page banner section --> */}
      {/* <div>
        <h1>home page banner section</h1>
        <div className="noise-banner-section" ref={sliderRef}>
          <Slider {...settings}>
            <div className="always-connected-slider-card">
              <div className="always-connected-slider-image">
                <picture>
                  <source media="(max-width: 768px)" srcSet={NoiseMobileWebp} />
                  <img className="banner-image" src={NoiseWebWebp} alt="Banner" loading="lazy" />
                </picture>
              </div>
            </div>
            <div className="always-connected-slider-card">
              <div className="always-connected-slider-image">
                <picture>
                  <source media="(max-width: 768px)" srcSet={NoiseMobileWebp} />
                  <img className="banner-image" src={NoiseWebWebp} alt="Banner" loading="lazy" />
                </picture>
              </div>
            </div>
          </Slider>
        </div>
      </div> */}

      <div id="info-section" className="noiseinfo-section" data-aos="fade-up">
        <div className="info-container-web">
          <img src={DisFeatureWeb} className="" />
        </div>
        <div className="info-container-mobile">
          <img src={DisFeatureMobile} className="" />
        </div>
      </div>
    </>
  );
};

export default React.memo(NoiseInfoSection);
